import { useMeQuery } from 'core';

interface ILmsAccessBlock {
  isBlocked: boolean;
  reason: string | null;
  overdueAmount: number | null;
  activeRole: string | null;
}

/**
 * Reads the student's LMS-access block from the `me` query (spec 0003). Returns
 * `isBlocked=false` for everyone with access. `cache-and-network` so an
 * in-session block/unblock surfaces on the next mount, not only a hard reload.
 * `activeRole` lets the banner avoid showing in a teacher/methodist session.
 */
export const useLmsAccessBlock = (): ILmsAccessBlock => {
  const { data } = useMeQuery({ fetchPolicy: 'cache-and-network' });
  const block = data?.me?.lmsAccessBlock;

  return {
    isBlocked: Boolean(block?.isBlocked),
    reason: block?.reason ?? null,
    overdueAmount: block?.overdueAmount ?? null,
    activeRole: data?.me?.activeRole ?? null,
  };
};
